import { createContext, useContext, useEffect } from "react";

const AuthContext = createContext();

const REFRESH_INTERVAL = 1 * 60 * 1000; // 15 minutes

export const AuthProvider = ({ children }) => {
    const backendurl = window.location.hostname === 'localhost'
    ? ''
    : process.env.REACT_APP_BACKEND_URL;
    
  const handleRefreshToken = async () => {
    // console.log("refreshToken",localStorage.getItem("refreshToken"));
    const refreshToken = localStorage.getItem("refreshToken");

    if (!refreshToken) {
        console.error("No refresh token found");
        return null; // Exit early if there's no refresh token
    }
    
    try {
      const response = await fetch(`${backendurl}/signup/refresh-token`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ refreshToken }),
      });

      const data = await response.json();
      if (response.ok) {

        // console.log("idtoken;" ,data.IdToken)
        // console.log("idtokenrefreshed;" ,data)
        localStorage.setItem("authToken", data.IdToken);
        localStorage.setItem("accessToken", data.AccessToken);
        console.log("Token refreshed successfully");
      } else {
        // console.log("refreshToken",localStorage.getItem("refreshToken"));
        console.error("Failed to refresh token:", data.message);
      }
    } catch (error) {
      console.error("Error refreshing token:", error);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleRefreshToken();
    }, REFRESH_INTERVAL);

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return <AuthContext.Provider value={{}}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
